<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEmitClose() {
      this.$emit('close')
    },
    onEmitEdit() {
      // this.data.userGroupIds=[]
      this.$emit('edit', this.data)
    },
    onEmitView() {
      this.$emit('view', this.data)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="[$style.block, { [$style['is-disabled']]: data.block }]">{{ data.block === 0 ? '啟用中' : '停權中' }}</div>
    <div :class="$style.inner" @click="onEmitView">
      <el-avatar :src="data.avatar" :size="90"></el-avatar>

      <h4 :class="$style['inner__name']">{{ data.name }}</h4>
      <h5> {{ data.title }} </h5>
      <div :class="$style.title" v-if="data.userGroups.length > 0">
        <span 
        v-for="(userGroups, index) in data.userGroups" 
        :key="index" 
        class="pb-2"
        style="line-height: 1.5">{{userGroups.title}}{{ index + 1 === data.userGroups.length ? '' : '、'}}</span>
      </div>
      <template v-if="showDetail">
        <p>{{ `${data.phoneCode} ${data.phoneNumber}` }}</p>
        <p v-if="data.certificate">證照：{{ data.certificate }}</p>
        <p v-if="data.specialty">專長：{{ data.specialty }}</p>
        <p>{{ data.description }}</p>
      </template>
    </div>
    <div class="d-flex flex-wrap justify-content-around">
      <span v-if="data.storeTitles.length" class="pb-2" style="line-height: 1.5">{{data.storeTitles.join('、')}}</span>
      <!-- <div v-for="(store) in data.storeTitles" :key="store" class="mb-2">{{ store }}</div> -->
    </div>
    <el-button v-if="showDetail" @click="onEmitClose">關閉</el-button>
    <!-- <el-button class="is-round icon-left-top" type="primary" plain @click="onEmitEdit">編輯</el-button> -->
    <!-- <el-button class="is-round icon-left-top" type="primary" plain @click="onEmitEdit"><BaseIcon name="edit" /></el-button> -->
  </div>
</template>

<style lang="scss" module>
:global{
  .icon-left-top{
    position: absolute;
    left: 10px;
    top: 10px;
    border: 0;
    padding: 10px 13px !important;

  }
}
.container {
  text-align: center;
  position: relative;
  border: 1px solid #E5E7EB;
  border-radius: $border-radius;
}
.inner {
  margin-bottom: 15px;
  &__name {
    color: $color-primary;
  }
}
.title {
  color: $color-text-secondary;
}
.block {
  position: absolute;
  top: 16px;
  right: 0;
  color: white;
  background: #12C494;
  padding: 7px 14px;
  font-size: 12px;
  &.is-disabled {
    background: #e35d5d;
  }
}
</style>
